module.exports = __webpack_public_path__ + "img/how-to-img02.4e4080c9.png";